export default __webpack_public_path__ + "static/media/confirm.18f1de76.svg";